import Modal from 'antd/lib/modal';
import React, { ReactElement, useContext, useMemo, useState } from 'react';
import ModalContext from 'context/ModalContext';
import { Spin } from 'antd';
import { FormattedMessage } from 'react-intl';

import { SModal } from './styles';

interface ModalComponentProps {
  id: string;
  component: React.Component;
  bottomControl?: React.Component;
  title?: string;
  titleId?: string;

  onShow: () => {};
  onHide: () => {};
  handleOk: () => boolean;
  handleCancel: () => boolean;

  isHideFooter: boolean;
  heightFull: boolean;
  closable: boolean;
  centered?: boolean;
  cancelButtonProps?: object;
  isForceRender: boolean;
  superModal: boolean;
  submitType: boolean;
}

const ModalComponent: React.FC<ModalComponentProps> = (props) => {
  const context = useContext(ModalContext);
  const { showModal, hideModal } = context;

  const [isLoading, setLoading] = useState(false);

  var {
    id,
    closable = true,
    component,
    rawComponent,
    titleId,
    handleOk = () => true,
    handleCancel = () => true,
    title,
    centered,
    bottomControl,
    cancelButtonProps
  } = props;

  const _component = useMemo(
    (arg) => {
      if (!component) return;
      return React.cloneElement(component, { ...context.params[id] });
    },
    [context.params[id]]
  );

  const _handleOk = async () => {
    setLoading(true);
    try {
      var close = await handleOk();
      setLoading(false);
      if (close) {
        hideModal(id);
      }
    } catch (e) {
      setLoading(false);
      // hideModal(id);
    }
  };

  const _handleCancel = () => {
    handleCancel();
    hideModal(id);
  };

  return (
    <SModal
      closable={closable}
      visible={context.visible[id]}
      maskClosable={true}
      destroyOnClose={true}
      onOk={_handleOk}
      closeIcon={false}
      centered={centered}
      title={titleId ? <FormattedMessage id={titleId} /> : title}
      cancelButtonProps={cancelButtonProps}
      okButtonProps={{ loading: isLoading ? true : false }}
      onCancel={_handleCancel}
      {...props}
    >
      <Spin spinning={isLoading}>{rawComponent || _component}</Spin>
    </SModal>
  );
};

export default ModalComponent;
